import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    name:'index',
    component: () => import('../views/index/index.vue'),
    meta:{
      title:'湖南艾尼科技有限公司首页',
      content:{
        keywords:'艾尼科技为全球消费者提供简单易用的软件产品。',
        description:'艾尼科技为全球消费者提供简单易用的软件产品。'
      }
    }
  },
  {
    path:'/about',
    name:'about',
    component:()=> import('../views/about/index.vue'),
    meta:{
      title:'湖南艾尼科技有限公司介绍',
      content:{
        keywords:'艾尼科技是湖南具影响力，有代表性的软件开发商，正致力于打造全球知名应用软件品牌。',
        description:'艾尼科技是湖南具影响力，有代表性的软件开发商，正致力于打造全球知名应用软件品牌。'
      }
    }
  },
  {
    path:'/news',
    name:'uiwuNews',
    component:()=> import('../views/news/index.vue'),
    meta:{
      title:'湖南艾尼科技有限公司新闻',
      content:{
        keywords:'实时了解艾尼科技新闻动态。',
        description:'实时了解艾尼科技新闻动态。'
      }
    }
  },
  {
    path:'/details',
    name:'uiwuDetails',
    component:()=> import('../views/news/details.vue'),
    meta:{
      title:'文章详情',
      content:{
        keywords:'实时了解艾尼科技新闻动态。',
        description:'实时了解艾尼科技新闻动态。'
      }
    }
  },
  {
    path:'/recruit',
    name:'uiwuRecruit',
    component:()=> import('../views/recruit/index.vue'),
    meta:{
      title:'湖南艾尼科技有限公司招聘',
      content:{
        keywords:'艾尼科技提供宽松舒适的工作环境，广阔的事业发展空间，真诚期待您的加入！',
        description:'艾尼科技提供宽松舒适的工作环境，广阔的事业发展空间，真诚期待您的加入！'
      }
    }
    
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})
// {
//   path: '/',
//   name: 'home',
//   component: HomeView
// },
// {
//   path: '/about',
//   name: 'about',
//   // route level code-splitting
//   // this generates a separate chunk (about.[hash].js) for this route
//   // which is lazy-loaded when the route is visited.
//   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
// },
export default router
